import { render, staticRenderFns } from "./FMintOverviewList.vue?vue&type=template&id=0c896267&"
import script from "./FMintOverviewList.vue?vue&type=script&lang=js&"
export * from "./FMintOverviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports